import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IPropsDeleteItem } from './type'
import { requestDeleteItemManagement } from 'app/api/item'
import { ItemMessageCode } from 'app/api/item/constant'
import { isEqual } from 'lodash'
import { notificationController } from 'app/controllers/notification-controller'
import R from 'app/assets/R'
import { ResponseType } from 'parkway-web-common'

export const useModalHook = (props: IPropsDeleteItem) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const handleSubmit = async () => {
    setIsLoading(true)
    try {
      const response: ResponseType<string> = await requestDeleteItemManagement(
        props?.id,
      )

      if (
        isEqual(
          response?.msgcode,
          ItemMessageCode.ItemManagement.successDeleteData,
        )
      ) {
        setIsLoading(false)
        handleCancel()
        props?.fetchTable?.()
        notificationController.success({
          message: t(R.strings.delete_account),
          description: response?.message,
        })
      } else {
        notificationController.error({
          message: t(R.strings.delete_account),
          description: response?.message,
        })
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  return {
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
  }
}
